import { InstanceDashboardStack } from 'component/navigation/instance';

export const unstable_settings = {
    initialRouteName: 'index',
};

export default function InstanceDashboardSpacesLayout() {
    return <InstanceDashboardStack />;
}
